function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import clsx from 'clsx';
import { string } from 'prop-types';
import FormGroup from '@mui/material/FormGroup';
const SovosFormGroup = _ref => {
  let {
    className,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement(FormGroup, _extends({
    className: clsx('sovosFormGroup', className)
  }, rest));
};
SovosFormGroup.propTypes = {
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
SovosFormGroup.baseComponent = {
  name: 'Form Group',
  link: 'form-group/'
};
export default SovosFormGroup;